type PayrollAccess = {
  hasAccess: boolean;
  canManage?: (key: string) => boolean;
};

const SELF_SERVICE_ROLES = new Set(["employee", "intern"]);

export const canUsePayrollRecords = (
  role: string | null | undefined,
  access: PayrollAccess
): boolean => {
  const normalizedRole = (role || "").trim().toLowerCase();
  if (SELF_SERVICE_ROLES.has(normalizedRole)) return false;
  if (!access.hasAccess) return true;
  return access.canManage?.("payroll-records") === true;
};
